


























import { sortBy } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { Auth } from 'aws-amplify'

import { $db } from '@/services/Db'

import EditableTable from '@/components/EditableTable.vue'
import CouponForm from './CouponForm.vue'
import BulkCreateCoupons from './BulkCreateCoupons.vue'
import Downloader from '@/components/Downloader.vue'

@Component({ components: { EditableTable, CouponForm, BulkCreateCoupons, Downloader } })
export default class CouponsPage extends Vue {

	req = { loading: true, errors: [] }
	coupons: any[] = []
	sub: { unsubscribe: () => void } | null = null

	columns = ['id', 'SKU', 'expires', 'license']

	editing = null
	newSymbol = Symbol('New Coupon')

	created() {
		this.req.loading = true
		const { data, subscription } = $db.subscribe('coupons', 'Coupon', 'id SKU expires license', this, 'coupons')
		this.sub = subscription
		data.then(items => this.coupons = items)
			.catch(err => this.req.errors = Array.isArray(err.errors) ? err.errors.map(e => e.message) : [err.message])
			.finally(() => this.req.loading = false)
	}

	destroyed() {
		if(this.sub) {
			this.sub.unsubscribe()
		}
	}

}
